const flights = {
  flight: "رحلة جوية", // translated 
  flights: "الرحلات الجوية", // translated 
  originDepartureDate: "رحيل", // translated 
  destinationDepartureDate: "يعود", // translated 
  outbound: "الصادرة", // translated 
  inbound: "واردة", // translated 
  travelTime: "وقت السفر", // translated 
  selected: "المحدد", // translated 
  select: "يختار", // translated 
  airline: "شركة طيران", // translated 
  directFlight: "رحلة مباشرة", // translated 
  baggage: "أمتعة", // translated 
  stops: "توقف", // translated 
  nonStop: "بدون توقف", // translated 
  oneStopMax: "وقفة واحدة كحد أقصى", // translated 
  twoStopsMax: "محطتين كحد أقصى", // translated 
  anyStops: "مع أي توقف", // translated 
  smallBaggage: "الأمتعة الصغيرة", // translated 
  bigBaggage: "أمتعة كبيرة", // translated 
  smallAndBigBaggage: "الأمتعة الصغيرة والكبيرة", // translated 
  outboundStops: "توقف الصادرة", // translated 
  inboundStops: "توقف الواردة", // translated 
  selectAirline: "اختر شركة الطيران", // translated 
  baggageOption: "خيار الأمتعة", // translated 
  outboundDepartureAfter: "المغادرة للخارج بعد", // translated 
  outboundArrivalAfter: "الوصول للخارج بعد", // translated 
  inboundDepartureAfter: "المغادرة الداخلية بعد", // translated 
  inboundArrivalTimeAfter: "وصول الوارد بعد", // translated 
  flightClass: "فئة الطيران", // translated 
  outboundDepAfter: "المغادرة بعد", // translated 
  outboundArrivalAfrer: "وصول الخروج بعد", // translated 
  inboundDepAfter: "في الرحيل بعد", // translated 
  inboundArrivalAfter: "في الوصول بعد", // translated 
  airlines: "الخطوط الجوية)", // translated 
  lessThan: "أقل من", // translated 
  layover: "توقف", // translated 
  duration: "مدة", // translated 
  noClassPreference: "لا يوجد تفضيل للفئة", // translated 
  economy: "اقتصاد", // translated 
  business: "عمل", // translated 
  with: "مع", // translated 
  without: "بدون", // translated 
  twoOrMore: "اثنان أو أكثر", // translated 
  departure: "رحيل", // translated 
  return: "يعود", // translated 
  submit: "يُقدِّم", // translated 
  priceLessThan: "السعر أقل من", // translated 
  durationLessThan: "المدة أقل من", // translated 
  layoverLessThan: "توقف أقل من", // translated 
  noLayover: "لا توقف", // translated 
  durationLowestFirst: "المدة (الأدنى أولاً)", // translated 
  durationHighestFirst: "المدة (الأعلى أولاً)", // translated 
  idType: "نوع الهوية", // translated 
  idPassportCode: "رمز الهوية/جواز السفر", // translated 
  expirationDate: "تاريخ انتهاء الصلاحية", // translated 
  frequentFlyerNumber: "رقم المسافر الدائم", // translated 
  frequentFlyerAirline: "المسافر الدائم طيران", // translated 
  dateOfBirth: "تاريخ الميلاد", // translated 
  infant: "رضيع", // translated 
  phone: "هاتف", // translated 
  title: "عنوان", // translated 
  noLuggageIncluded: "لا تشمل الأمتعة", // translated 
  includesLuggage: "يشمل الأمتعة", // translated 
  outboundFlight: "رحلة الى الخارج", // translated 
  inboundFlight: "رحلة قادمة", // translated 
  flightNumber: "رقم الرحلة الجوية", // translated 
  flightNumbers: "أرقام الرحلة", // translated 
  cabinClassType: "نوع فئة المقصورة", // translated 
  class: "فصل", // translated 
  aircraft: "الطائرات", // translated 
  aircraftType: "نوع الطائرة", // translated 
  airlineName: "اسم شركة الطيران", // translated 
  no: "لا", // translated 
  yes: "نعم", // translated 
  anyFlights: "أي رحلات", // translated 
  oneStop: "توقف واحد", // translated 
  direct: "مباشر", // translated 
  directFlights: "الرحلات الجوية المباشرة", // translated 
  all: "الجميع", // translated 
  first: "أولاً", // translated 
  premiumEconomy: "بريم. اقتصاد", // translated 
  withBaggageOnly: "مع الأمتعة فقط", // translated 
  oneWay: "طريقة واحدة", // translated 
  roundTrip: "جولة", // translated 
  withBaggage: "مع الأمتعة", // translated 
  noBaggagePreference: "لا توجد تفضيلات للأمتعة", // translated 
  noBaggage: "لا الأمتعة", // translated 
  requiredFields: "الحقول المطلوبة", // translated 
  nonRequiredFields: "الحقول غير المطلوبة", // translated 
  cabinClass: "فئة المقصورة", // translated 
  brandName: "اسم العلامة التجارية", // translated 
  performNewSearch: "إجراء بحث جديد", // translated 
  outboundDeparture: "المغادرة للخارج", // translated 
  inboundDeparture: "المغادرة الواردة", // translated 
  created: "مخلوق", // translated 
  freeCancellationAvailable: "الإلغاء المجاني متاح", // translated 
  freeCancellationDeadline: "الموعد النهائي للإلغاء المجاني", // translated 
  externalReference: "مرجع خارجي", // translated 
  outboundflightNumber: "رقم الرحلة المغادرة", // translated 
  inboundflightNumber: "رقم الرحلة القادمة", // translated 
  arrival: "الوصول", // translated 
};



export default flights;
